import SectionWrapper from "../../../components/layout/SectionWrapper";
import styled from "../../../util/styled";

const PREFIX = "MetronomeCarousel";

export const classes = {
  container: `${PREFIX}-container`,
  carousel: `${PREFIX}-carousel`,
  navButton: `${PREFIX}-navButton`,
  navWrapper: `${PREFIX}-navWrapper`,
  activeIndicator: `${PREFIX}-activeIndicator`,
};

export const StyledSectionWrapper = styled(SectionWrapper)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.carousel}`]: {},
  [`& .${classes.navWrapper}`]: {
    [`&:hover .${classes.navButton}`]: {
      backgroundColor: theme.palette.ibOrange.light,
      color: theme.palette.ibOrange.main,
      filter: "none",
      opacity: 1,
    },
  },
  [`& .${classes.navButton}`]: {
    backgroundColor: theme.palette.ibOrange.main,
  },
  [`& .${classes.activeIndicator}`]: {
    color: theme.palette.ibPurple.main,
    "&:hover": {
      color: theme.palette.ibPurple.light,
    },
  },
}));
